import * as React from "react"
import { useEffect } from "react";
import { Box } from "@mui/material"

import { CommonFilters } from "@components";
import {COMMON_FILTER_KEYS, GROUPED_BY, SHARE_OF_SEARCH_ROUTES, STOCK_ROUTES} from "@constants";
import { useAppDefaultFilters } from "@hooks";
import {isLoadingCommonFilters, isSystemBusy, splitKpi} from "@signals";
import { shareOfSearchKpiIsEmpty } from "./@signals";
import { batch } from "@preact/signals-react";


export default function ShareOfSearchKpiFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(SHARE_OF_SEARCH_ROUTES.SHARE_ID, SHARE_OF_SEARCH_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	return <Box data-tour="sos-kpi-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			favFilters: true, splitKpi: true,
			favFiltersOnlyLine: true, keyword: true,
		}}
		compProps={{
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.KEYWORD, COMMON_FILTER_KEYS.SPLIT_KPI],
				dashboardKey: SHARE_OF_SEARCH_ROUTES.SHARE_ID
			},
			site: { grid: { xs: 12, md: 6 } },
			country: { grid: { xs: 12, md: 6 } },
			keyword: { grid: { xs: 12, md: 6 } },
			splitKpi: {
				grid: { xs: 12, md: 6 },
				value: splitKpi.value.some(v => v === GROUPED_BY.BRAND || v === GROUPED_BY.SELLER) ? splitKpi.value = [] : splitKpi.value,
				excludeOptions: [GROUPED_BY.BRAND, GROUPED_BY.SELLER, GROUPED_BY.SKU, GROUPED_BY.COMPANY]
			},
		}}
		onSubmit={() => batch(() => {
			isLoadingCommonFilters.value = true
			isSystemBusy.value = false
			shareOfSearchKpiIsEmpty.value = false
		})}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}